import React, { useState } from "react";
import Header from "./Header/Header";
import DashboardSidebar from "./Sidebar/DashboardSidebar";

const DashboardLayout = props => {
	const { expandedSection, setExpandedSection ,isManageEventsPage = false } = props;

	return (
		<>
			<div className="">
				<DashboardSidebar
					{...props}
					expandedSection={expandedSection}
					setExpandedSection={setExpandedSection}
					
				/>
				<div className={`${!props?.prefeventinfo ? "" : "dashboard-content"}`}>
					<Header
						{...props}
						expandedSection={expandedSection}
						setExpandedSection={setExpandedSection}
						isManageEventsPage={isManageEventsPage}
					/>
					{props.children}
				</div>
			</div>
			<style>{`
                .dashboard-content {
                    background-color: ${localStorage.getItem("darkMode") ? "#2f2f2f" : "auto"}
                }
            `}</style>
		</>
	);
};

export default DashboardLayout;
